module.exports = __webpack_public_path__ + "static/media/benemite.b03afa96.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/climasense/aranha_roja_fresa/preventiva/benemite.png
// module id = 1540
// module chunks = 3